import { Action, SubjectRoles } from "@/api-schema-enums";
import { AppAbility } from "@/casl-provider";
import { User } from "@/store/user-store";
import { AbilityBuilder } from "@casl/ability";

export function setVehicleBlockPermissions(user: User, builder: AbilityBuilder<AppAbility>) {
  const { can } = builder;

  if (user.roles.includes(SubjectRoles.FitIntModerator)) {
    can(Action.Manage, "VehicleBlock");
  } else {
    can(Action.Read, "VehicleBlock");
  }
}
